import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  profiles: [],
};


const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET magictype
    getmagictypeSuccess(state, action) {
      state.isLoading = false;
      state.profiles = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;


// ----------------------------------------------------------------------

export function getmagictypes() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('cuurent-account');
      console.log(response,'magictype--->>>>')
      dispatch(slice.actions.getmagictypeSuccess(response?.data?.account));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

